module.exports = __webpack_public_path__ + "static/img/eureka_icon_6.64ae1780.png";